import React from 'react'

import {Icon} from '@lazarusai/forms-ui-components'

import '../styles/SelectPill.css'

export default function SelectPill(props) {
  return (
    <div className='pill-main'>
      <div className='contents'>
        <Icon
          icon={'file-add-outline'}
        />
        <span>
          {props.text}
        </span>
        <Icon
          icon={'plus-outline'}
        />
      </div>
    </div>
  )
}
